import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ArrowRight } from 'lucide-react';
import { navLinks } from '../../data/mock';

/**
 * Floating pill navigation. Gains a slightly stronger surface once the page
 * scrolls, so it separates from content without ever feeling heavy.
 */
const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close the mobile sheet whenever the route changes.
  useEffect(() => setMobileMenuOpen(false), [location.pathname]);

  return (
    <header className={`nav-header ${scrolled ? 'is-scrolled' : ''}`}>
      <Link to="/" className="flex items-center gap-2" aria-label="Tenses home">
        <img src="/tenses-blue-logo.png" alt="Tenses" className="h-7" />
      </Link>

      {/* Desktop navigation */}
      <nav className="hidden items-center gap-1 md:flex">
        {navLinks.map((link) => (
          <Link
            key={link.name}
            to={link.href}
            className={`nav-link ${location.pathname === link.href ? 'is-active' : ''}`}
          >
            {link.name}
          </Link>
        ))}
      </nav>

      <div className="hidden items-center gap-2 md:flex">
        <a
          href="https://app.tenses.ai"
          className="nav-link"
          style={{ color: 'var(--text-primary)' }}
        >
          Sign in
        </a>
        <a href="https://app.tenses.ai" className="btn-primary" style={{ minHeight: 42, padding: '0 20px', fontSize: '0.9rem' }}>
          Start free
          <ArrowRight className="h-3.5 w-3.5" />
        </a>
      </div>

      {/* Mobile trigger */}
      <button
        className="grid h-10 w-10 place-items-center rounded-full md:hidden"
        onClick={() => setMobileMenuOpen((v) => !v)}
        aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
        aria-expanded={mobileMenuOpen}
      >
        {mobileMenuOpen ? <X size={20} /> : <Menu size={20} />}
      </button>

      {/* Mobile sheet */}
      {mobileMenuOpen && (
        <div
          className="absolute left-0 right-0 top-full mx-2 mt-2 rounded-3xl bg-white p-4 md:hidden"
          style={{ border: '1px solid var(--border-light)', boxShadow: 'var(--shadow-xl)' }}
        >
          <nav className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.href}
                className={`nav-link py-3 ${location.pathname === link.href ? 'is-active' : ''}`}
              >
                {link.name}
              </Link>
            ))}
            <a href="https://app.tenses.ai" className="btn-primary mt-3">
              Get started
              <ArrowRight className="h-4 w-4" />
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
